import {ActionType, developerStateType} from "./types";

const defaultState = {
    name: '',
    partnerNo: '',
    merchantNo: '',
    signKey: '',
    signKeyModal: false,
    storeList: [],
    productList: []
}


const developer = (state: developerStateType = defaultState, action: ActionType<any>) => {
    switch (action.type) {
        case 'SET_DEVELOPER_INFO':
            return {
                ...state,
                ...action.payload
            }
        case 'SET_SIGN_KEY':
            return {
                ...state,
                signKey: action.payload.signKey,
                signKeyModal: false
            }
        case 'SIGN_KEY_MODAL_STATUS':
            return {
                ...state,
                signKeyModal: action.payload.status
            }
        default:
            return state;
    }
}

export default developer